import { getTextColor, hexToRgb } from './color-utils'

const createStyleBlock = (key) => {
    const b = document.createElement('style')
    b.dataset.css = key
    return b
}

const styleBlockCache = new Map()

export const getOrCreateStyleBlock = (key) => {
    let block = styleBlockCache.get(key)

    if (block) { return block }

    block = document.querySelector(`[data-css="${key}"]`)

    if (!block) {
        block = createStyleBlock(key)
        document.head.appendChild(block)
    }
    styleBlockCache.set(key, block)

    return block
}

export const createCssVariablesCode = (color) => {
    const css = Object
        .keys(color)
        .map(key => `--${key}: ${color[key]};`)
        .join('');
    return `:root {${css}}`;
}

export const updateBodyThemeClass = (themeName) => {
    document.body.classList.remove('theme--light', 'theme--dark')
    document.body.classList.add(`theme--${themeName}`)
}

export const createVuetifyTextColorCSS = (colors) => {
    const bgs = ['primary', 'secondary']

    return bgs.reduce((css, color) => {
        const textColor = colors[`on-${color}`]

        // Since vuetify always set color for ui elements as background-color in rgb we are able to change it color style
        const styleSelector =  `[style*="background-color: ${hexToRgb(colors[color])}"]`
        const classSelector = `.${color}`

        const styleScope = `{color:${textColor}!important;fill:${textColor}!important;}`

        return css + `${styleSelector}, ${classSelector} ${styleScope}\n`
    }, '')
}

export const vuetifyTextColorClasses = (colors) => {
    return Object.keys(colors).reduce((css, colorName) => {
        const classSelector = `.${colorName}`
        const textColor = getTextColor(colors[colorName])

        const styleScope = `{color:${textColor}!important;fill:${textColor}!important;}`

        return css + `${classSelector} ${styleScope}\n`
    })
}